import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

import '../../../styles/MenuScreen.css';
import ApplicationStep from '../../common/ApplicationStep';
import DetailsScreen from './DetailsScreen';
import MenusAndProductsScreen from './MenusAndProductsScreen';

import {
    logOutCustomer, clearWizardData, clearState, clearTemporaryOrderTimeData, openChangeOrderTimeScreen, saveNewOrderTime, loadAllAvailableDiscounts,
    getRestaurantAvailableMenus, getSelectedProduct, getSelectedProductForEdit, clearMessageAlert, selectRestaurantMenu, openStartOrderScreen,
    selectedMenuArrayIndex, getOldestActiveLoyalty, dispatchPromoCodeToStore, getServiceMessages, clearServiceMessages, changeAuthipayBackBtnFlag,
    editProduct, getComoMemberDetails, addProductToCart, toggleSearchProductFocus, toggleShoppingCartModal, setProductsQty,
    setTimeSlotTakenAppRedirectNotice
} from '../../../../actions/index';
import { setLastOpenedPagePWA, 
    checkIfMenuIsAvailable, 
    checkIfCategoryIsAvailable, 
    checkIfProductIsAvailable 
} from "../../../../utils/CommonUtils";
import { calculateProductPrice } from '../../../../utils/ProductWizardUtils';
import { updateCSSVariables } from '../../../../utils/ThemesSelector';
import { pushDataToGoogleTagManager, getProductCategory } from '../../../../utils/AnalyticsUtils';
import ShoppingCartButton from '../../../../components/order/shoppingCart/shoppingCartBtn/ShoppingCartButton';
// import CommonModal from '../../../../components/common/CommonModal';
// import FreeProduct from '../../../../components/order/shoppingCart/FreeProduct';
import { ARABIC, FRONT_END_URL } from '../../../../utils/Constants';
import CartItemsButton from '../../../../components/order/menu/CartItemsButton';
import { Col } from 'reactstrap';
import ShoppingCart from '../../../../components/order/shoppingCart/ShoppingCart';
import { totalItemsCount } from '../../../../utils/ShoppingCartUtils';
import { isIOS } from 'mobile-device-detect';

/* Inline header (no portal) on menu screen: header and cart in same layer to avoid tap/click conflicts.
 * Note: Non-portaled header was tried before and did not work for multiple implementations.
 * Set to false: header is portaled to body so it stays visible when scrolling to a category (fixed relative to viewport).
 * Set to true: header inline – can disappear when clicking a category because fixed is relative to transformed ancestor. */
const MENU_SCREEN_USE_INLINE_HEADER = false;

/** iOS only: wait for drawer slide to finish before updating header classes. */
const IOS_MENU_DRAWER_CLOSE_HEADER_DELAY_MS = 180;

class MenuScreenPwa extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedProduct: null,
            // isFreeProductModalOpen: false,
            isCartModalOpen: false,
            currentProductsQty: 0,
            showHeaderBrandName: false,
            headerSolid: false,
            cartOverlayRect: null,
            headerHidden: false,
            drawerOpen: false
        }

        this.cartWrapperRef = React.createRef();
        this.menuSelectedRef = false;
        this.animateHeader = this.animateHeader.bind(this);
        this.editProductFromCart = this.editProductFromCart.bind(this);
        this.handleMenuSelected = this.handleMenuSelected.bind(this);
        this.throttledFunction = _.throttle(this.animateHeader, 300);
        this.updateCartOverlayRect = this.updateCartOverlayRect.bind(this);
        this.smoothScrollToTopAndSyncHeader = this.smoothScrollToTopAndSyncHeader.bind(this);
        this.menuHeaderTopSentinelRef = React.createRef();
        /** @type {IntersectionObserver | null} */
        this._menuTopIntersectionObserver = null;
        /** iOS: null until first IO callback — then whether the top sentinel intersects the viewport (replaces scrollY<=1 for “at top” header). */
        this._iosMenuTopIntersecting = null;
    }

    setupIosMenuTopObserver() {
        if (!isIOS || typeof IntersectionObserver === 'undefined') return;
        const el = this.menuHeaderTopSentinelRef.current;
        if (!el || this._menuTopIntersectionObserver) return;
        this._menuTopIntersectionObserver = new IntersectionObserver(
            (entries) => {
                const e = entries[0];
                if (!e) return;
                this._iosMenuTopIntersecting = e.isIntersecting;
                if (this.isMenuHeaderDebug()) {
                    this.logMenuHeaderDebug('io-callback', true);
                }
                requestAnimationFrame(() => this.animateHeader());
            },
            { root: null, rootMargin: '0px', threshold: [0, 1] }
        );
        this._menuTopIntersectionObserver.observe(el);
    }

    teardownIosMenuTopObserver() {
        if (this._menuTopIntersectionObserver) {
            try {
                this._menuTopIntersectionObserver.disconnect();
            } catch (_) {}
            this._menuTopIntersectionObserver = null;
        }
        this._iosMenuTopIntersecting = null;
    }

    /** Strip stale multi-menu nav layout (class/inline height) after restaurant or menu-count changes. */
    resetMenuNavigationLayout() {
        const nav = document.getElementById('menuNavigationContainer');
        if (nav) {
            nav.classList.remove('menu-nav-multi-menu');
            nav.style.removeProperty('min-height');
            nav.style.removeProperty('height');
        }
        document.body.classList.remove('header-visible');
    }

    /** Matches translateY(50px) on fixed #menuNavigationContainer (react-sticky topOffset -50 on Android). */
    getMenuNavPinLine() {
        return 52;
    }

    /** iOS: keep category bar in document flow until its holder reaches the pin line (gradual stick like Android). */
    syncMenuNavigationPinFromScroll(scrollPosition) {
        if (!isIOS) return;
        const nav = document.getElementById('menuNavigationContainer');
        if (!nav) return;

        const atPageTop = this.isAtMenuScrollTop(scrollPosition);
        const holder = nav.parentElement;
        const holderTop = holder ? holder.getBoundingClientRect().top : Number.MAX_SAFE_INTEGER;
        const pinLine = this.getMenuNavPinLine();
        const hysteresis = 4;
        const inFlow = document.body.classList.contains('menu-at-top');

        let shouldFlow;
        if (atPageTop) {
            shouldFlow = true;
        } else if (inFlow) {
            shouldFlow = holderTop > pinLine;
        } else {
            shouldFlow = holderTop > pinLine + hysteresis;
        }

        this.applyMenuNavigationFlowState(shouldFlow, 'pin-from-scroll', { holderTop, pinLine, atPageTop });
    }

    applyMenuNavigationFlowState(shouldFlow, debugReason, debugExtra) {
        if (!isIOS) return;
        const inFlow = document.body.classList.contains('menu-at-top');
        if (shouldFlow === inFlow) return;
        const nav = document.getElementById('menuNavigationContainer');
        if (shouldFlow) {
            document.body.classList.add('menu-at-top');
            if (nav) {
                nav.classList.remove('sticky');
                nav.classList.remove('stickyProductBarTop');
                nav.style.setProperty('position', 'relative', 'important');
                nav.style.setProperty('top', 'auto', 'important');
                nav.style.setProperty('transform', 'none', 'important');
                if (nav.parentElement) {
                    nav.parentElement.style.minHeight = '0';
                }
            }
            this.logMenuHeaderDebug(debugReason || 'sync-nav-in-flow', true, debugExtra);
        } else {
            document.body.classList.remove('menu-at-top');
            if (nav) {
                nav.style.removeProperty('position');
                nav.style.removeProperty('top');
                nav.style.removeProperty('transform');
                if (nav.parentElement) {
                    nav.parentElement.style.removeProperty('min-height');
                }
            }
            this.logMenuHeaderDebug(debugReason || 'sync-nav-pinned', true, debugExtra);
        }
    }

    /** iOS at scroll top: category bar belongs in page flow below banner/details, not fixed under the header. */
    syncMenuNavigationAtTop(isAtTop) {
        this.applyMenuNavigationFlowState(isAtTop, isAtTop ? 'sync-nav-at-top' : 'sync-nav-scrolled');
    }

    isAtMenuScrollTop(scrollPosition) {
        if (!isIOS) return scrollPosition <= 1;
        /* Real devices (e.g. iOS 18.7.x) can report IO false or scrollY > 1 at visual top — combine both signals. */
        if (scrollPosition <= 5) return true;
        if (scrollPosition > 40) return false;
        return this._iosMenuTopIntersecting === true;
    }

    /** After add-to-cart: jump to top, then sync header (same as pre-scroll menu-top behavior). */
    smoothScrollToTopAndSyncHeader() {
        if (isIOS) {
            this._iosMenuTopIntersecting = true;
            this.syncMenuNavigationAtTop(true);
            document.body.classList.remove('header-visible');
        }
        try {
            window.scrollTo(0, 0);
        } catch (_) {
            window.scrollTo(0, 0);
        }
        if (document.documentElement) document.documentElement.scrollTop = 0;
        if (document.body) document.body.scrollTop = 0;
        const contentEl = document.getElementById('contentContainerTransparent');
        if (contentEl && typeof contentEl.scrollTop !== 'undefined') contentEl.scrollTop = 0;
        requestAnimationFrame(() => {
            this.animateHeader();
            if (isIOS) {
                try {
                    window.dispatchEvent(new Event('scroll'));
                } catch (_) {}
            }
            this.logMenuHeaderDebug('scroll-to-top-after-cart', true);
        });
    }

    updateCartOverlayRect() {
        if (MENU_SCREEN_USE_INLINE_HEADER || !isIOS || !this.cartWrapperRef.current) return;
        const el = this.cartWrapperRef.current;
        const rect = el.getBoundingClientRect();
        const maxHeight = 60;
        const cartOverlayRect = {
            top: rect.top,
            left: rect.left,
            width: Math.max(rect.width, 56),
            height: Math.min(rect.height, maxHeight),
        };
        try {
            console.log('[Cart overlay] rect', JSON.stringify(cartOverlayRect));
            if (this.isCartOverlayDebug()) console.log('[Cart overlay] debug=cart is ON');
        } catch (_) {}
        this.setState({ cartOverlayRect });
    }

    isCartOverlayDebug() {
        if (typeof window === 'undefined') return false;
        const search = window.location.search || '';
        const hash = window.location.hash || '';
        return search.includes('debug=cart') || hash.includes('debug=cart');
    }

    isMenuHeaderDebug() {
        if (typeof window === 'undefined') return false;
        const search = window.location.search || '';
        const hash = window.location.hash || '';
        return search.includes('debug=menu-header') || hash.includes('debug=menu-header');
    }

    collectMenuHeaderDebugSnapshot(reason) {
        const header = document.getElementById('headerContainerTransparent');
        const nav = document.getElementById('menuNavigationContainer');
        const scrollY = Math.round(window.scrollY || 0);
        const atScrollTop = this.isAtMenuScrollTop(scrollY);
        const headerRect = header ? header.getBoundingClientRect() : null;
        const navRect = nav ? nav.getBoundingClientRect() : null;
        const holderRect = nav && nav.parentElement ? nav.parentElement.getBoundingClientRect() : null;
        const navStyle = nav && window.getComputedStyle ? window.getComputedStyle(nav) : null;
        const headerStyle = header && window.getComputedStyle ? window.getComputedStyle(header) : null;

        return {
            reason,
            scrollY,
            atScrollTop,
            iosMenuTopIntersecting: this._iosMenuTopIntersecting,
            menuNavPinLine: this.getMenuNavPinLine(),
            navInFlow: document.body.classList.contains('menu-at-top'),
            holderTop: holderRect ? Math.round(holderRect.top) : null,
            bodyClass: document.body.className,
            menusCount: this.props.menus ? this.props.menus.length : 0,
            header: header ? {
                className: header.className,
                top: headerRect ? Math.round(headerRect.top) : null,
                height: headerRect ? Math.round(headerRect.height) : null,
                position: headerStyle ? headerStyle.position : null,
                transform: headerStyle ? headerStyle.transform : null,
                backgroundColor: headerStyle ? headerStyle.backgroundColor : null,
            } : null,
            nav: nav ? {
                className: nav.className,
                top: navRect ? Math.round(navRect.top) : null,
                height: navRect ? Math.round(navRect.height) : null,
                position: navStyle ? navStyle.position : null,
                transform: navStyle ? navStyle.transform : null,
                holderMinHeight: nav.parentElement ? nav.parentElement.style.minHeight || null : null,
            } : null,
        };
    }

    logMenuHeaderDebug(reason, force, debugExtra) {
        if (!this.isMenuHeaderDebug()) return;
        try {
            const snap = this.collectMenuHeaderDebugSnapshot(reason);
            if (debugExtra) Object.assign(snap, debugExtra);
            const key = JSON.stringify(snap);
            if (!force && reason === 'animateHeader' && key === this._lastMenuHeaderDebugKey) {
                return;
            }
            this._lastMenuHeaderDebugKey = key;
            console.log('[Menu header debug]', snap);
        } catch (_) {}
    }

    setupMenuHeaderDebug() {
        if (!this.isMenuHeaderDebug()) return;
        try {
            console.log('[Menu header debug] enabled – add debug=menu-header to URL; call window.__dumpMenuHeaderDebug() anytime');
        } catch (_) {}
        this.logMenuHeaderDebug('mount', true);
        if (typeof window !== 'undefined') {
            window.__dumpMenuHeaderDebug = () => this.logMenuHeaderDebug('manual', true);
        }
        this._menuHeaderDebugScroll = _.throttle(() => this.logMenuHeaderDebug('scroll', true), 800);
        window.addEventListener('scroll', this._menuHeaderDebugScroll, false);
    }

    teardownMenuHeaderDebug() {
        if (this._menuHeaderDebugScroll) {
            window.removeEventListener('scroll', this._menuHeaderDebugScroll, false);
            this._menuHeaderDebugScroll = null;
        }
        if (typeof window !== 'undefined' && window.__dumpMenuHeaderDebug) {
            try {
                delete window.__dumpMenuHeaderDebug;
            } catch (_) {
                window.__dumpMenuHeaderDebug = undefined;
            }
        }
    }

    /** Re-run top-of-menu nav/header sync once #menuNavigationContainer exists (first app open). */
    syncMenuLayoutWhenNavReady() {
        if (!isIOS) return;
        const attempt = () => {
            const nav = document.getElementById('menuNavigationContainer');
            if (!nav) {
                requestAnimationFrame(attempt);
                return;
            }
            if (this.isAtMenuScrollTop(Math.round(window.scrollY))) {
                this._iosMenuTopIntersecting = true;
                this.syncMenuNavigationPinFromScroll(Math.round(window.scrollY));
                document.body.classList.remove('header-visible');
                this.animateHeader();
            }
        };
        requestAnimationFrame(attempt);
    }

    componentDidMount() {
        this.resetMenuNavigationLayout();
        this.props.clearServiceMessages();
        this.props.getServiceMessages(this.props.restaurant.restaurantId, this.props.selectedOrderType.value);

        const isComo = this.props.promotionPartners.promotionPartner && this.props.promotionPartners.promotionPartner.id === 2;
        if (isComo) {
            this.props.getComoMemberDetails();
        }

        updateCSSVariables(this.props.customerThemes.selectedTheme.colorsCss);

        const comingFromProductOrMealDealWizard = this.props.temporaryOrderTime.currentPagePath.includes('/order/product/') ||
            this.props.temporaryOrderTime.currentPagePath.includes('order/discounts');

        // If we are coming to the menu component from product wizard DO NOT reload the page data
        if (!comingFromProductOrMealDealWizard) {
            const { restaurantId } = this.props.restaurant;
            this.props.loadAllAvailableDiscounts(restaurantId);
            this.props.getRestaurantAvailableMenus();
        }

        /* Menu screen body class for header CSS (Android: hide/show restAndBrandName by sticky; iOS: also ios-device) */
        document.body.classList.add('menu-screen');
        if (isIOS) {
            document.body.classList.add('ios-device');
            /* Scope CSS only — does not change header logic (animateHeader / portaled header unchanged) */
            document.documentElement.classList.add('ios-menu-screen');
            if (window.scrollY <= 5) {
                this._iosMenuTopIntersecting = true;
                this.syncMenuNavigationAtTop(true);
                document.body.classList.remove('header-visible');
            }
            setTimeout(() => this.animateHeader(), 0);
            this.syncMenuLayoutWhenNavReady();
        }

        /* After add-to-cart: product wizard closed and we're back on menu – jump to top + sync header */
        if (typeof window !== 'undefined' && window.__menuScrollToTopAfterAddToCart) {
            window.__menuScrollToTopAfterAddToCart = false;
            if (isIOS) {
                this._iosMenuTopIntersecting = true;
                this.syncMenuNavigationAtTop(true);
                document.body.classList.remove('header-visible');
            }
            setTimeout(() => this.smoothScrollToTopAndSyncHeader(), 200);
        }

        window.addEventListener('scroll', this.throttledFunction, false);

        if (isIOS && !MENU_SCREEN_USE_INLINE_HEADER) {
            setTimeout(() => this.updateCartOverlayRect(), 300);
            window.addEventListener('scroll', this.updateCartOverlayRect, true);
            window.addEventListener('resize', this.updateCartOverlayRect);
        }
        if (isIOS && !MENU_SCREEN_USE_INLINE_HEADER && this.isCartOverlayDebug()) {
            try { console.log('[Cart overlay] debug=cart enabled – tap right side to see tap target'); } catch (_) {}
            this._cartDebugTap = (e) => {
                const x = e.touches ? e.touches[0].clientX : e.clientX;
                const y = e.touches ? e.touches[0].clientY : e.clientY;
                const rightEdge = window.innerWidth;
                if (rightEdge - x > 80) return;
                const target = e.target;
                try {
                    console.log('[Cart overlay debug] tap', e.type, 'x=' + x, 'y=' + y, 'target=', target.id || target.className || target.tagName);
                } catch (_) {}
            };
            document.addEventListener('touchstart', this._cartDebugTap, true);
            document.addEventListener('click', this._cartDebugTap, true);
        }

        /* Single menu: still sync header after menus settle (layout). Do not set menuSelectedRef — that
         * forced header-at-top + brand at scroll top (same as "menu chosen" from dropdown); multi-menu
         * never had that, and one-menu brands should match (header hidden at top on Android / iOS bar). */
        if (this.props.menus && this.props.menus.length === 1) {
            setTimeout(() => this.animateHeader(), 700);
        }

        setLastOpenedPagePWA(this.props.openChangeOrderTimeScreen);

        const { customer } = this.props;
        const appliedPromotions = this.props.shoppingCart ? this.props.shoppingCart.appliedPromotions : null;
        let isAppliedPromotionWithPromoCode = false;
        if(appliedPromotions && appliedPromotions.length) {
            appliedPromotions.map((promotion, index) => {
                if(promotion.promoCode) {
                    isAppliedPromotionWithPromoCode = true;
                }
            })
        }
        // Gets an active loyalty code whenever user is logged in
        if (customer.token && !this.props.storeLocalStorage.codeManuallySet && customer.autoApplyLoyalty && !isAppliedPromotionWithPromoCode) {
            this.props.getOldestActiveLoyalty();
        }

        if (this.props.paymentProvider.providerType && this.props.paymentProvider.providerType.id === 4) {
            //set menu screen flag to local storage when authipay is configured 
            this.props.changeAuthipayBackBtnFlag(true);
        }

        if (isIOS && typeof IntersectionObserver !== 'undefined') {
            const attach = () => {
                if (this.menuHeaderTopSentinelRef.current) {
                    this.setupIosMenuTopObserver();
                } else {
                    requestAnimationFrame(attach);
                }
            };
            requestAnimationFrame(attach);
        }

        this.setupMenuHeaderDebug();
    }

    componentDidUpdate(prevProps, prevState) {
        const prevRestaurantId = prevProps.restaurant && prevProps.restaurant.restaurantId;
        const currentRestaurantId = this.props.restaurant && this.props.restaurant.restaurantId;
        if (prevRestaurantId !== currentRestaurantId) {
            this.resetMenuNavigationLayout();
            if (isIOS) {
                this._iosMenuTopIntersecting = window.scrollY <= 1;
                document.body.classList.remove('header-visible');
            }
            const comingFromProductOrMealDealWizard = this.props.temporaryOrderTime.currentPagePath.includes('/order/product/') ||
                this.props.temporaryOrderTime.currentPagePath.includes('order/discounts');
            if (!comingFromProductOrMealDealWizard) {
                this.props.getRestaurantAvailableMenus();
            }
            requestAnimationFrame(() => this.animateHeader());
        } else if (prevProps.menus.length > 1 && this.props.menus.length === 1) {
            this.resetMenuNavigationLayout();
            if (isIOS) {
                this._iosMenuTopIntersecting = window.scrollY <= 1;
                document.body.classList.remove('header-visible');
            }
            requestAnimationFrame(() => this.animateHeader());
        } else if (
            isIOS &&
            prevProps.menus.length === 0 &&
            this.props.menus.length > 0 &&
            this.isAtMenuScrollTop(Math.round(window.scrollY))
        ) {
            this.syncMenuNavigationAtTop(true);
            document.body.classList.remove('header-visible');
            requestAnimationFrame(() => this.animateHeader());
        }

        // Free product modal now handled only by ShoppingCart (avoids duplicate commonModal divs)
        // if ((prevProps.shoppingCart.orderProducts !== this.props.shoppingCart.orderProducts) && (!this.props.loyalty.oldestActiveCode || this.props.storeLocalStorage.codeManuallySet)) {
        //     this.checkHasFreeProduct(prevProps.shoppingCart.orderProducts, this.props.shoppingCart.orderProducts);
        // }

        if(this.props.currentProductsQty > prevProps.currentProductsQty) {
            let cartItemsIcon = document.getElementById("cartItemsIcon");
            let cartItemsNumber = document.getElementById("cartItemsNumber");


            if (cartItemsIcon !== null && cartItemsIcon !== undefined) {
                if (cartItemsIcon.classList.value.includes("cartItemsIconAnimation") && cartItemsNumber.classList.value.includes("cartItemsNumberAnimation")) {
                    cartItemsIcon.classList.remove("cartItemsIconAnimation");
                    cartItemsNumber.classList.remove("cartItemsNumberAnimation");
                    cartItemsIcon.classList.add("enlargeAnimation");
                    cartItemsNumber.classList.add("flipAnimation")
                } else if (cartItemsIcon.classList.value.includes("enlargeAnimation") && cartItemsNumber.classList.value.includes("flipAnimation")) {
                    cartItemsIcon.classList.remove("enlargeAnimation");
                    cartItemsNumber.classList.remove("flipAnimation");
                    cartItemsIcon.classList.add("cartItemsIconAnimation");
                    cartItemsNumber.classList.add("cartItemsNumberAnimation");
                } else {
                    cartItemsIcon.classList.add("cartItemsIconAnimation");
                    cartItemsNumber.classList.add("cartItemsNumberAnimation");
                }
            }
        }

        if(prevProps.shoppingCart.orderProducts !== this.props.shoppingCart.orderProducts) {
            this.props.setProductsQty(totalItemsCount(this.props.shoppingCart))
        }

        if (!MENU_SCREEN_USE_INLINE_HEADER && isIOS && this.cartWrapperRef.current && !this.state.cartOverlayRect) {
            requestAnimationFrame(() => this.updateCartOverlayRect());
        }

        if (prevState.isCartModalOpen && !this.state.isCartModalOpen) {
            setTimeout(() => this.animateHeader(), 50);
        }

        /* After add-to-cart: menu stayed mounted (e.g. wizard route) – same scroll-to-top as didMount */
        const currPath = this.props.location && this.props.location.pathname ? this.props.location.pathname : '';
        const onMenuPath = currPath.includes('/order/menu');
        const flagSet = typeof window !== 'undefined' && window.__menuScrollToTopAfterAddToCart;
        if (flagSet && onMenuPath) {
            window.__menuScrollToTopAfterAddToCart = false;
            if (isIOS) {
                this._iosMenuTopIntersecting = true;
                this.syncMenuNavigationAtTop(true);
                document.body.classList.remove('header-visible');
            }
            setTimeout(() => this.smoothScrollToTopAndSyncHeader(), 200);
        }
    }

    /* Sync body class so iOS can position #menuNavigationContainer below header when header is visible.
     * When iOS uses sticky-200 + menu-header-top at scroll top (minimal transparent bar), sticky-200 alone
     * would make this true and add body.header-visible — extra offset below banner. Ignore sticky* when
     * menu-header-top unless header-at-top (solid bar with brand). */
    syncHeaderVisibleBodyClass() {
        const header = document.getElementById('headerContainerTransparent');
        if (!header) {
            document.body.classList.remove('header-visible');
            return;
        }
        if (document.body.classList.contains('menu-at-top')) {
            document.body.classList.remove('header-visible');
            return;
        }
        const nav = document.getElementById('menuNavigationContainer');
        const headerHeight = header.getBoundingClientRect().height || 60;
        const navTop = nav ? nav.getBoundingClientRect().top : 0;
        const navIsPinnedNearHeader = !nav || navTop <= headerHeight + 20;
        const minimalTop = header.classList.contains('menu-header-top');
        const visible =
            navIsPinnedNearHeader &&
            (header.classList.contains('header-at-top') ||
            (!minimalTop &&
                (header.classList.contains('sticky') ||
                    header.classList.contains('sticky-100') ||
                    header.classList.contains('sticky-200'))));
        if (visible) {
            document.body.classList.add('header-visible');
        } else {
            document.body.classList.remove('header-visible');
        }
    }

    /* Called when user selects a menu from the menusContainer dropdown. Do NOT show solid header
       (header-at-top) in that case – only the single-menu-on-load case should show it. */
    handleMenuSelected() {
        this.menuSelectedRef = false;
        const header = document.getElementById('headerContainerTransparent');
        if (header) {
            header.classList.remove('header-at-top');
        }
        this.syncHeaderVisibleBodyClass();
        this.setState({ showHeaderBrandName: false, headerSolid: false });
        setTimeout(() => this.animateHeader(), 650);
    }

    animateHeader() {
        const scrollPosition = Math.round(window.scrollY);
        const header = document.getElementById('headerContainerTransparent');

        const atScrollTop = this.isAtMenuScrollTop(scrollPosition);

        if (isIOS) {
            this.syncMenuNavigationPinFromScroll(scrollPosition);
        }

        if (atScrollTop) {
            if (header) {
                if (isIOS) {
                    /* iOS: sticky-200 + menu-header-top (CSS in Common.css under body.ios-device.menu-screen) */
                    header.classList.remove('header-hidden');
                    header.classList.remove('sticky');
                    header.classList.remove('sticky-100');
                    header.classList.add('sticky-200');
                    header.classList.add('menu-header-top');
                } else {
                    /* Android: previous top-of-menu behavior — do not apply iOS-only classes */
                    header.classList.add('header-hidden');
                    header.classList.remove('sticky');
                    header.classList.remove('sticky-100');
                    header.classList.remove('sticky-200');
                    header.classList.remove('menu-header-top');
                }
                if (this.menuSelectedRef) {
                    header.classList.add('header-at-top');
                } else {
                    header.classList.remove('header-at-top');
                }
            }
            /* When drawer is open, keep header visible (don't set headerHidden) so after close it stays visible. iOS menu only. */
            const hideHeader = !this.state.drawerOpen;
            if (this.menuSelectedRef) {
                this.setState({ showHeaderBrandName: true, headerSolid: true, headerHidden: hideHeader });
            } else {
                if (isIOS) document.body.classList.remove('header-visible');
                this.setState({ showHeaderBrandName: false, headerSolid: false, headerHidden: hideHeader });
            }
        } else {
            if (header) {
                header.classList.remove('header-hidden');
                header.classList.remove('menu-header-top');
            }
            this.setState({ headerHidden: false });
            if (!MENU_SCREEN_USE_INLINE_HEADER && isIOS) {
                requestAnimationFrame(() => this.updateCartOverlayRect());
            }
            if (scrollPosition <= 100) {
                if (header) {
                    header.classList.remove('header-at-top');
                    header.classList.add('sticky');
                    header.classList.remove('sticky-100');
                    header.classList.remove('sticky-200');
                }
                this.setState({ showHeaderBrandName: false, headerSolid: false });
            } else if (scrollPosition < 200) {
                if (header) {
                    header.classList.remove('header-at-top');
                    header.classList.add('sticky-100');
                    header.classList.remove('sticky');
                    header.classList.remove('sticky-200');
                }
                this.setState({ showHeaderBrandName: true, headerSolid: false });
            } else {
                if (header) {
                    header.classList.remove('header-at-top');
                    header.classList.add('sticky-200');
                    header.classList.remove('sticky');
                    header.classList.remove('sticky-100');
                }
                this.setState({ showHeaderBrandName: true, headerSolid: false });
            }
        }
        this.syncHeaderVisibleBodyClass();
        this.logMenuHeaderDebug('animateHeader');
    }

    componentWillUnmount() {
        this.teardownMenuHeaderDebug();
        this.teardownIosMenuTopObserver();
        document.documentElement.classList.remove('ios-menu-screen');
        document.body.classList.remove('header-visible');
        document.body.classList.remove('menu-screen');
        document.body.classList.remove('menu-at-top');
        if (isIOS) {
            document.body.classList.remove('ios-device');
            window.removeEventListener('scroll', this.updateCartOverlayRect, true);
            window.removeEventListener('resize', this.updateCartOverlayRect);
        }
        if (this._cartDebugTap) {
            document.removeEventListener('touchstart', this._cartDebugTap, true);
            document.removeEventListener('click', this._cartDebugTap, true);
        }
        window.removeEventListener('scroll', this.throttledFunction, false);
    }

    selectProduct(product) {
        const filteredProduct = {
            id: product.id,
            name: product.name,
            price: product.price,
            category: getProductCategory(product.id, this.props.products, this.props.categories)
        };
        pushDataToGoogleTagManager('event', 'view-item', this.props.pwaAppRunning, filteredProduct);

        const isMenuAvailable = checkIfMenuIsAvailable(this.props.menus, product.menuId);
        const isCategoryAvailable = checkIfCategoryIsAvailable(this.props.categories, this.props.products, product);
        const isProductAvailable = checkIfProductIsAvailable(this.props.products, product);
        const isAvailable = isMenuAvailable && isCategoryAvailable && isProductAvailable;

        // Preload product image so it is in cache when product screen opens (single fix for image delay)
        const enableLargeImageDesign = (this.props.selectedRestaurant && this.props.selectedRestaurant.enableLargeImageDesign) || (this.props.estimateOrderTime && this.props.estimateOrderTime.enableLargeImageDesign);
        const imagePath = enableLargeImageDesign ? product.rectImagePath : product.imagePath;
        if (imagePath) {
            const img = new Image();
            img.src = `${FRONT_END_URL}/${imagePath}`;
        }

        this.props.history.push({ pathname: '/brand/' + this.props.brandId + '/order/product/' + product.id });
    }

    editProductFromCart(product, index) {
        const filteredProduct = {
            id: product.id,
            name: product.name,
            price: product.price,
            category: getProductCategory(product.id, this.props.products, this.props.categories)
        };
        pushDataToGoogleTagManager('event', 'view-item', this.props.pwaAppRunning, filteredProduct);

        if (product.promotionFreeProduct) {
            this.props.getSelectedProduct(product.id, (productUpdated) => {
                this.props.editProduct(productUpdated, index, (productUpdated) => {
                    this.props.history.push({
                        pathname: '/brand/' + this.props.brand.id + '/order/product/' + product.id,
                        editProduct: {
                            product: productUpdated
                        }
                    });
                }, product)
            }, product.quantity);
        } else {
            this.props.editProduct(product, index, (productUpdated) => {
                this.props.history.push({
                    pathname: '/brand/' + this.props.brand.id + '/order/product/' + product.id,
                    editProduct: {
                        product: productUpdated
                    }
                })
            })
        }
    }

    // autoAddToCart(itemToAdd) {
    //     const { selectedRestaurant, products, categories } = this.props;
    //     let currency = selectedRestaurant.currency;
        
    //     itemToAdd.instruction = null;

    //     if (!itemToAdd.quantity) {
    //         itemToAdd.quantity = 1;
    //     }

    //     // Google Analytics
    //     let filteredProduct = {
    //         id: itemToAdd.id,
    //         currency: currency,
    //         name: itemToAdd.name,
    //         price: calculateProductPrice(selectedRestaurant.allowToppingSubstitution, itemToAdd.price, itemToAdd.quantity, itemToAdd),
    //         quantity: itemToAdd.quantity,
    //         category: getProductCategory(itemToAdd.id, products, categories)
    //     };

    //     pushDataToGoogleTagManager('event', 'addToCart', this.props.pwaAppRunning, filteredProduct);

    //     this.props.addProductToCart(itemToAdd);
    // }

    // toggleFreeProductModal = () => {
    //     this.setState({
    //         ...this.state,
    //         isFreeProductModalOpen: !this.state.isFreeProductModalOpen
    //     })
    // }

    // checkHasFreeProduct = (prevProducts, products) => {
    //     let currentFreeProduct = {};
    //     let prevFreeProduct = {};
    //     products.map((product) => {
    //         if (product.promotionFreeProduct) {
    //             currentFreeProduct = product;
    //         }
    //     })
    //     prevProducts.map(prevProduct => {
    //         if (prevProduct.promotionFreeProduct) {
    //             prevFreeProduct = prevProduct
    //         }
    //     })
    //     if (prevFreeProduct.id !== currentFreeProduct.id && Object.entries(currentFreeProduct).length) {
    //         this.toggleFreeProductModal();
    //     }
    // }

    toggleCartModal() {

        this.setState({
            ...this.state,
            isCartModalOpen: !this.state.isCartModalOpen
        });

        let shoppingCartDesktopWrapper = document.getElementById("shoppingCartDesktopWrapper");
        const isArabic = this.props.language === ARABIC;

        if (isArabic) {
            if (shoppingCartDesktopWrapper !== null && shoppingCartDesktopWrapper.classList.value.includes("shoppingCartInactiveRTL")) {
                shoppingCartDesktopWrapper.classList.remove("shoppingCartInactiveRTL");
                shoppingCartDesktopWrapper.classList.add("shoppingCartActiveRTL");
            } else if (shoppingCartDesktopWrapper !== null && shoppingCartDesktopWrapper.classList.value.includes("shoppingCartActive")) {
                shoppingCartDesktopWrapper.classList.remove("shoppingCartActiveRTL");
                shoppingCartDesktopWrapper.classList.add("shoppingCartInactiveRTL");
            } else {
                shoppingCartDesktopWrapper.classList.add("shoppingCartActiveRTL");
            }
        } else {
            if (shoppingCartDesktopWrapper !== null && shoppingCartDesktopWrapper.classList.value.includes("shoppingCartInactive")) {
                shoppingCartDesktopWrapper.classList.remove("shoppingCartInactive");
                shoppingCartDesktopWrapper.classList.add("shoppingCartActive");
            } else if (shoppingCartDesktopWrapper !== null && shoppingCartDesktopWrapper.classList.value.includes("shoppingCartActive")) {
                shoppingCartDesktopWrapper.classList.remove("shoppingCartActive");
                shoppingCartDesktopWrapper.classList.add("shoppingCartInactive");
            } else {
                shoppingCartDesktopWrapper.classList.add("shoppingCartActive");
            }
        }
    }

    renderShoppingCart(cartWrapperRef) {
        const isArabic = this.props.language === ARABIC;
        const ref = cartWrapperRef || this.cartWrapperRef;
        
        if (this.props.menus !== undefined && this.props.menus !== null && this.props.menus.length > 0) {
			const singleMenu = this.props.menus.length === 1;
			/* Multi-menu: do not stretch cart vertically (parent can be menu row + category row); that centered the icon between rows. */
			/* Single-menu: align to top of the category strip — alignItems:center + nested column centered the bag on iOS while Android looked ok */
			/* Single-menu: in-flow flex item (last in nav row) — absolute+right broke on Android with mobile display:unset / RTL ancestors */
			const cartColStyle = singleMenu
				? {
					position: 'relative',
					flex: '0 0 52px',
					width: 52,
					alignSelf: 'stretch',
					height: 60,
					minWidth: 52,
					maxWidth: 52,
					zIndex: 10,
					display: 'flex',
					alignItems: 'flex-start',
					justifyContent: 'center',
					paddingTop: 14,
					paddingLeft: 0,
					paddingRight: 10,
					boxSizing: 'border-box',
					pointerEvents: 'auto',
				}
				: { position: 'absolute', right: 0, zIndex: 10 };

			return (
				<Col
					ref={ref}
					className={`menuScreenCartWrapper${singleMenu ? ' menuScreenCartSingleMenu' : ''}`}
					style={cartColStyle}
				>
					{singleMenu ? (
						<CartItemsButton
							{...this.props}
							isArabic={isArabic}
							toggleCartModal={this.toggleCartModal.bind(this)}
						/>
					) : (
						<div style={isArabic ? { display: 'flex', flexDirection: 'column', paddingLeft: '10px' } : { display: 'flex', flexDirection: 'column', paddingRight: '10px' }}>
							<div className="stickyProfile" style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
								<CartItemsButton
									{...this.props}
									isArabic={isArabic}
									toggleCartModal={this.toggleCartModal.bind(this)}
								/>
							</div>
						</div>
					)}
				</Col>
			);
        }
    }

    renderMenuScreenContent() {
        const isArabic = this.props.language === ARABIC;
        const enableLargeImageDesign = this.props.restaurant ? this.props.restaurant.enableLargeImageDesign : null;
        let shoppingCartDesktopWrapper = document.getElementById("shoppingCartDesktopWrapper");
        let shoppingCartWrapperStyle = shoppingCartDesktopWrapper && (shoppingCartDesktopWrapper.classList.value.includes("shoppingCartActive") || shoppingCartDesktopWrapper.classList.value.includes("shoppingCartActiveRTL")) ? { width: '100%' } : null;
        /* Dimmer uses z-index 10040 — must be above #menuNavigationContainer (500 on iOS) so the menu dropdown is not on top of the cart; drawer must be above the dimmer (see app.css z-index 20 default). */
        if (this.state.isCartModalOpen) {
            shoppingCartWrapperStyle = { ...(shoppingCartWrapperStyle || {}), zIndex: 10050 };
        }

        return (
            <Fragment>
                {isIOS ? (
                    <div
                        id="iosMenuHeaderTopSentinel"
                        ref={this.menuHeaderTopSentinelRef}
                        aria-hidden
                        style={{
                            height: 1,
                            width: '100%',
                            margin: 0,
                            padding: 0,
                            pointerEvents: 'none',
                            overflow: 'hidden',
                            visibility: 'hidden',
                        }}
                    />
                ) : null}
                <DetailsScreen
                    history={this.props.history}
                    customer={this.props.customer}
                    brandName={this.props.brandName}
                    brand={this.props.brand}
                    restaurant={this.props.restaurant}
                    bannerImagePath={this.props.bannerImagePath}
                    orderTypes={this.props.orderTypes}
                    selectedOrderType={this.props.selectedOrderType}
                    estimateOrderTime={this.props.estimateOrderTime}
                    temporaryOrderTime={this.props.temporaryOrderTime}
                    changeOrderTimeScreenOpened={this.props.changeOrderTimeScreenOpened}
                    selectedDeliveryAddress={this.props.selectedDeliveryAddress}
                    menuPreviewMode={this.props.menuPreviewMode}
                    customerThemes={this.props.customerThemes}
                    shoppingCart={this.props.shoppingCart}
                    clearWizardData={this.props.clearWizardData}
                    clearState={this.props.clearState}
                    clearTemporaryOrderTimeData={this.props.clearTemporaryOrderTimeData}
                    setTimeSlotTakenAppRedirectNotice={this.props.setTimeSlotTakenAppRedirectNotice}
                    availableDiscounts={this.props.availableDiscounts}
                    loyalty={this.props.loyalty}
                    isArabic={isArabic}
                />

                <MenusAndProductsScreen
                    loading={this.props.loading}
                    customer={this.props.customer}
                    restaurant={this.props.restaurant}
                    menus={this.props.menus}
                    menuPreviewMode={this.props.menuPreviewMode}
                    categories={this.props.categories}
                    products={this.props.products}
                    shoppingCart={this.props.shoppingCart}
                    selectedProduct={this.props.selectedProduct}
                    errorMessage={this.props.errorMessage}
                    alertMessage={this.props.alertMessage}
                    customerThemes={this.props.customerThemes}
                    startOrder={this.props.startOrder}
                    availableDiscounts={this.props.availableDiscounts}
                    isPwaApp={true}
                    selectRestaurantMenu={this.props.selectRestaurantMenu}
                    selectedMenuArrayIndex={this.props.selectedMenuArrayIndex}
                    currentMenuArrayIndex={this.props.currentMenuArrayIndex}
                    selectProduct={this.selectProduct.bind(this)}
                    clearMessageAlert={this.props.clearMessageAlert}
                    generalNote={this.props.menuDescription.generalNote}
                    isArabic={isArabic}
                    enableLargeImageDesign={enableLargeImageDesign}
                    toggleSearchProductFocus={this.props.toggleSearchProductFocus}
                    isShoppingCartModalOpen={this.props.isShoppingCartModalOpen}
                    toggleShoppingCartModal={this.props.toggleShoppingCartModal}
                    renderShoppingCart={this.renderShoppingCart.bind(this)}
                    cartWrapperRef={this.cartWrapperRef}
                    onMenuSelected={this.handleMenuSelected}
                />

                {
                    this.state.isCartModalOpen ?
                        <div onClick={() => this.toggleCartModal()} style={{ width: '100vw', height: '100vh', position: 'fixed', top: 0, left: 0, bottom: 0, right: 0, zIndex: 10040, backgroundColor: 'rgba(0, 0, 0, 0.5)', paddingBottom: isIOS ? '12px' : '0' }}></div> : null
                }
                <div id="shoppingCartDesktopWrapper" className={isArabic ? "shoppingCartDesktopWrapperRTL" : "shoppingCartDesktopWrapper"} style={shoppingCartWrapperStyle}>
                    <ShoppingCart
                        isCheckout={false}
                        // orderButton={checkoutButton}
                        history={this.props.history}
                        editProductFromCart={this.editProductFromCart}
                        selectProduct={this.selectProduct.bind(this)}
                        serviceNote={this.props.menuDescription.serviceNote}
                        enableLargeImageDesign={enableLargeImageDesign}
                        toggleCartModal={this.toggleCartModal.bind(this)}
                        isCartModalOpen={this.state.isCartModalOpen}
                    />
                </div>
                {/* Free product modal: handled only by ShoppingCart to avoid duplicate commonModal divs */}
                {/* {
                    this.state.isFreeProductModalOpen ?
                        <CommonModal isOpen={this.state.isFreeProductModalOpen} dialogName={`freeProduct`} toggle={this.toggleFreeProductModal} className='freeProduct'>
                            <FreeProduct
                                shoppingCart={this.props.shoppingCart}
                                onToggle={this.toggleFreeProductModal}
                                onEdit={this.editProductFromCart}
                                customerThemes={this.props.customerThemes}
                            />
                        </CommonModal> : null
                } */}
            </Fragment>
        );
    }

    render() {
        const isArabic = this.props.language === ARABIC;
        const headerText = isArabic ? `${this.props.restaurant.name} ${this.props.brand.name}` : `${this.props.brand.name} ${this.props.restaurant.name}`;
        const { cartOverlayRect } = this.state;
        const debugCart = this.isCartOverlayDebug();
        const cartTapOverlay = !MENU_SCREEN_USE_INLINE_HEADER && isIOS && cartOverlayRect && ReactDOM.createPortal(
            <div
                role="button"
                tabIndex={0}
                aria-label="Open cart"
                style={{
                    position: 'fixed',
                    top: cartOverlayRect.top,
                    left: cartOverlayRect.left,
                    width: cartOverlayRect.width,
                    height: cartOverlayRect.height,
                    zIndex: 99999,
                    ...(debugCart && {
                        outline: '3px solid red',
                        backgroundColor: 'rgba(255, 0, 0, 0.25)',
                    }),
                }}
                onClick={(e) => {
                    if (debugCart) console.log('[Cart overlay] onClick fired – overlay was hit');
                    e.stopPropagation();
                    e.preventDefault();
                    this.toggleCartModal();
                }}
                onTouchStart={(e) => {
                    if (debugCart) console.log('[Cart overlay] onTouchStart – overlay was hit');
                    e.stopPropagation();
                }}
                onTouchEnd={(e) => {
                    if (debugCart) console.log('[Cart overlay] onTouchEnd – overlay was hit');
                    e.stopPropagation();
                    e.preventDefault();
                    this.toggleCartModal();
                }}
            />,
            document.body
        );
        return (
            <Fragment>
                <ApplicationStep
                    hideBackButton={true}
                    transparentHeader={true}
                    portalHeaderOnIOS={!MENU_SCREEN_USE_INLINE_HEADER}
                    headerCartPassThrough={!MENU_SCREEN_USE_INLINE_HEADER}
                    hideHeader={this.state.isCartModalOpen}
                    headerHidden={this.state.headerHidden}
                    onDrawerOpenChange={isOpen => this.setState({ drawerOpen: isOpen }, () => {
                        if (!isOpen) {
                            if (isIOS) {
                                setTimeout(() => this.animateHeader(), IOS_MENU_DRAWER_CLOSE_HEADER_DELAY_MS);
                            } else {
                                setTimeout(() => this.animateHeader(), 0);
                            }
                        }
                    })}
                    text={headerText}
                    content={this.renderMenuScreenContent()}
                    showTransparentHeaderBrandName={this.state.showHeaderBrandName}
                    transparentHeaderSolid={this.state.headerSolid}
                />
                {cartTapOverlay}
                {!MENU_SCREEN_USE_INLINE_HEADER && isIOS && this.isCartOverlayDebug() && ReactDOM.createPortal(
                    <div
                        style={{
                            position: 'fixed',
                            bottom: 20,
                            left: 10,
                            zIndex: 10001,
                            padding: '6px 10px',
                            background: 'rgba(0,0,0,0.8)',
                            color: '#0f0',
                            fontSize: 12,
                            fontFamily: 'monospace',
                            borderRadius: 4,
                            pointerEvents: 'none',
                        }}
                    >
                        Cart debug ON
                        {this.state.cartOverlayRect && (
                            <div style={{ marginTop: 4, fontSize: 10, color: '#aaa' }}>
                                overlay: {Math.round(this.state.cartOverlayRect.top)}px from top
                            </div>
                        )}
                    </div>,
                    document.body
                )}
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        customer: state.customer,
        brandName: state.brand.name,
        brandId: state.brand.id,
        restaurant: state.selectedRestaurant,
        bannerImagePath: state.orderTypes.bannerImagePath,
        orderTypes: state.orderTypes.orderTypes,
        selectedOrderType: state.orderTypes.selectedOrderType,
        estimateOrderTime: state.estimateOrderTime,
        temporaryOrderTime: state.temporaryOrderTime,
        changeOrderTimeScreenOpened: state.temporaryOrderTime.changeOrderTimeScreenOpened,
        selectedDeliveryAddress: state.customer.selectedDeliveryAddress,
        menuPreviewMode: state.menuPreviewMode.previewMode,
        customerThemes: state.customerThemes,
        loading: state.loading,
        menus: state.restaurantMenus.menus,
        currentMenuArrayIndex: state.restaurantMenus.selectedMenuArrayIndex,
        categories: state.restaurantCategories,
        products: state.restaurantProducts,
        selectedProduct: state.selectedProduct,
        errorMessage: state.errorMessage,
        alertMessage: state.alertMessage,
        startOrder: state.startOrder,
        brand: state.brand,
        availableDiscounts: state.availableDiscounts,
        loyalty: state.loyalty,
        pwaAppRunning: state.pwaAppRunning,
        menuDescription: state.menuDescription,
        shoppingCart: state.shoppingCart,
        payment: state.payment,
        selectedRestaurant: state.selectedRestaurant,
        paymentProvider: state.paymentProvider,
        storeLocalStorage: state.storeLocalStorage,
        promotionPartners: state.promotionPartners,
        language: state.storeLocalStorage.language,
        isShoppingCartModalOpen: state.commonReducer.isShoppingCartModalOpen,
        currentProductsQty: state.productsQty.currentProductsQty
    };
};

export default connect(mapStateToProps, {
    logOutCustomer, clearWizardData, clearState, clearTemporaryOrderTimeData, openChangeOrderTimeScreen, saveNewOrderTime, loadAllAvailableDiscounts,
    getRestaurantAvailableMenus, getSelectedProduct, getSelectedProductForEdit, clearMessageAlert, selectRestaurantMenu, openStartOrderScreen,
    selectedMenuArrayIndex, getOldestActiveLoyalty, dispatchPromoCodeToStore, getServiceMessages, clearServiceMessages, changeAuthipayBackBtnFlag,
    editProduct,
    getComoMemberDetails, addProductToCart, toggleSearchProductFocus, toggleShoppingCartModal, setProductsQty,
    setTimeSlotTakenAppRedirectNotice
})(MenuScreenPwa);